import React, { useRef, useState } from "react"
import PropTypes from 'prop-types'
import Button from 'react-bootstrap/Button'
import { v4 as uuidv4 } from 'uuid'
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { CallData,EmbeddedGetEmbeddedRecognition,EmbeddedSetEmbeddedRecognition,EmbeddedGetEmbeddedRecognitionSelectedIndex,EmbeddedSetEmbeddedRecognitionSelectedIndex } from "../EmbeddedSupport.jsx"
import { EmbeddedDynamicsGetLastInsertedCallId, EmbeddedDynamicsSetLastInsertedCallId, EmbeddedDynamicsGetLastInsertedDynamicsCallId, EmbeddedDynamicsSetLastInsertedDynamicsCallId,
  EmbeddedDynamicsGetSettingAutoCreateCall, EmbeddedDynamicsGetSettingAutoOpenMatch, EmbeddedDynamicsGetSettingAutoCreateMatch, EmbeddedDynamicsGetSettingDefaultInboundCallSubject,
  EmbeddedDynamicsGetSettingDefaultInboundCallPriority, EmbeddedDynamicsGetSettingDefaultInboundCallDescription, EmbeddedDynamicsGetSettingDefaultOutboundCallSubject,
  EmbeddedDynamicsGetSettingDefaultOutboundCallPriority, EmbeddedDynamicsGetSettingDefaultOutboundCallDescription, EmbeddedDynamicsGetLastAutoOpenMatch,
  EmbeddedDynamicsSetLastAutoOpenMatch, EmbeddedDynamicsGetLastAutoCreateMatch, EmbeddedDynamicsSetLastAutoCreateMatch } from "./EmbeddedDynamicsSupport.jsx"
import Embedded from "../Embedded.jsx"
import { Translate } from "../../Components/Translator.jsx"
import { IsEmptyString, TimeDifferenceInMinutesAndSeconds, GetBrandButtonClass, explode, ucfirst } from "../../Components/GeneralFunctions.jsx"

import AccountPng from '../Assets/dynamics_account.png'
import ContactPng from '../Assets/embedded_contact.png'
import CreateCallPng from '../Assets/dynamics_createcall.png'
import CreateContactPng from '../Assets/dynamics_createcontact.png'
import CreateAccountPng from '../Assets/dynamics_createaccount.png'
import OpenCallPng from '../Assets/dynamics_opencall.png'

const EmbeddedDynamics = (props) => {

  const cEntities = [
    {type: "contact",  idField: "contactid",  phoneFields: ["telephone1","telephone2","telephone3","mobilephone"],  nameField: "fullname",    nameFieldCreate: "firstname",  png: ContactPng},
    {type: "account",  idField: "accountid",  phoneFields: ["telephone1","telephone2","telephone3"],                nameField: "name",        nameFieldCreate: "name",      png: AccountPng}
  ]

  const cPriorities = [
    {value: 0, caption: "Low priority"},
    {value: 1, caption: "Normal priority"},
    {value: 2, caption: "High priority"}
  ]

  const [mFrameOrigin, SetFrameOrigin] = useState("")
  const [mRepainter, SetRepainter] = useState("")  

  //Dynamics data retrieved from InitializeDynamics message
  const [mAppId, SetAppId] = useState("")
  const [mUserId, SetUserId] = useState("")
  const [mDynamicsUrl, SetDynamicsUrl] = useState("")

  const mWaitingForRecognitionContact = useRef(false)
  const mWaitingForRecognitionAccount = useRef(false)
  const mRecognitionBuffer = useRef([])

  const [mCallSubject, SetCallSubject] = useState("") //Local textbox content of the subject field 
  const [mCallPriority, SetCallPriority] = useState(0) //Local textbox content of the priority field 
  const [mCallDescription, SetCallDescription] = useState("") //Local textbox content of the description field 
   
  const mCreateRecordCache = useRef(null) //Will remember the last createRecord, so that when we get a response, we know what it is responding too

  //CLOUDCTI => DYNAMICS

  const DynamicsAPI_Send = (dynamicsVariable,dynamicsFunction) => 
  {    
    let message = {}
    message.variable = dynamicsVariable
    message.function = dynamicsFunction

    console.log("[TX Dynamics]", message)
    window.parent.postMessage(message, "*")  
  }  

  const DynamicsAPI_IntializeDynamics = async () => 
  {
    DynamicsAPI_Send(null, "intializeDynamics")
  }

  const DynamicsAPI_CreateCall = async (calldata,contact) => 
  {
    const partyOther = contact != null ? { ["partyid_" + contact.type + "@odata.bind"]: "/" + contact.type + "s(" + contact.id + ")", "participationtypemask": 1 } : null
    const partyMe = { "partyid_systemuser@odata.bind": "/systemusers(" + mUserId + ")", "participationtypemask": 2 }

    let activityParties = [partyMe]
    if (partyOther != null) { activityParties.push(partyOther)}

    const name = contact != null ? contact.name : ""

    const data = {
      phonenumber: calldata.opn,
      directioncode: !calldata.inbound, //false = inbound
      description: ReplaceFields(mCallDescription, calldata, name),
      subject: ReplaceFields(mCallSubject, calldata, name),
      prioritycode: mCallPriority,
      ["phonecall_activity_parties"]: activityParties,
      actualdurationminutes: !IsEmptyString(calldata.endedtime) ? (!IsEmptyString(calldata.answeredtime) ? Math.round((calldata.endedtime - calldata.answeredtime) / 60000) : 0) : null
    }
    if (contact != null) { data["regardingobjectid_" + contact.type + "@odata.bind"] = "/" + contact.type + "s(" + contact.id + ")" }

    mCreateRecordCache.current = {entity: "phonecall", callid: calldata.id}
    DynamicsAPI_Send(JSON.stringify({ entity: "phonecall", data: data }),"createRecord")
  }

  const DynamicsAPI_CreateEntity = async (number, entity) => 
  {
    if (entity == null)
    {
      console.log("Unknown entity")
      return
    }

    const name = "Caller " + number
    const data = {
      [entity.phoneFields[0]]: number,
      [entity.nameFieldCreate]: name
    }

    mCreateRecordCache.current = {entity: entity.type, name: name}
    DynamicsAPI_Send(JSON.stringify({ entity: entity.type, data: data }),"createRecord")
  }
  
  const DynamicsAPI_OpenEntity = (id,type) => 
  {
    DynamicsAPI_Send(JSON.stringify({ pageInput: { pageType: "entityrecord", entityName: type, entityId: id }, navigationOptions: { target: 1 } }), "navigateTo")
  }

  const DynamicsAPI_SearchNumber = (number) => 
  {
    cEntities.map((entity) => {
      let searchValueFilters = []
      entity.phoneFields.map((field) => { searchValueFilters.push("endswith(" + field + ",'" + number + "')") })
      DynamicsAPI_Send(JSON.stringify({ entity: entity.type, searchValue: "?$select=" + entity.idField + "," + entity.nameField + "&$filter=" + searchValueFilters.join(" or ")}), "searchNumber")
    })
  }
  
  const DynamicsAPI_UpdateCall = async (dynamicscallid, calldata, name) => 
  {
    const data = {
      description: ReplaceFields(mCallDescription,calldata,name),
      subject: ReplaceFields(mCallSubject,calldata,name),
      prioritycode: mCallPriority,
      actualdurationminutes: !IsEmptyString(calldata.endedtime) ? (!IsEmptyString(calldata.answeredtime) ? Math.round((calldata.endedtime - calldata.answeredtime) / 60000) : 0) : null
    }
    DynamicsAPI_Send(JSON.stringify({ entity: "phonecall", id: dynamicscallid, data: data }),"updateRecord")
  }

  const DynamicsAPI_UpdateCallDuration = async (dynamicscallid, calldata) => 
  {
    const data = {
      actualdurationminutes: !IsEmptyString(calldata.endedtime) ? (!IsEmptyString(calldata.answeredtime) ? Math.round((calldata.endedtime - calldata.answeredtime) / 60000) : 0) : null
    }
    DynamicsAPI_Send(JSON.stringify({ entity: "phonecall", id: dynamicscallid, data: data }),"updateRecord")
  }

  //DYNAMICS => CLOUDCTI

  function DynamicsAPI_ProcessEvent(event) 
  {
    console.log("[Dynamics RX]", event.origin, event.data);

    // IMPORTANT: check origin for security
    if ((mFrameOrigin !== "") && (event.origin !== mFrameOrigin)) return;

    try
    {
      if (event.data != null)
      {          
        if (event.data.InitializeDynamics != null)
        {
          DynamicsAPI_ProcessEvent_InitializeDynamics(event.data.InitializeDynamics)
        }
        else if (event.data.SearchNumber != null)
        {
          DynamicsAPI_ProcessEvent_SearchNumber(event.data.SearchNumber)
        }
        else if (event.data.CreateRecord != null)
        {
          DynamicsAPI_ProcessEvent_CreateRecord(event.data.CreateRecord)
        }
      }
    }
    catch (error)
    {
      console.log("Failed to process event", error)
    }
  }

  function DynamicsAPI_ProcessEvent_InitializeDynamics(initializeDynamicsEvent) 
  {
    if (initializeDynamicsEvent.error != null)
    {
      console.log("InitializeDynamics failed", initializeDynamicsEvent.error)
    }
    else if (initializeDynamicsEvent.response != null)
    {
      SetAppId(initializeDynamicsEvent.response.AppId)
      SetUserId(initializeDynamicsEvent.response.UserId?.replace(/^\{|\}$/g, '') ?? null)
      SetDynamicsUrl(initializeDynamicsEvent.response.DynamicsUrl)
    }
  }

  function DynamicsAPI_ProcessEvent_SearchNumber(searchNumberEvent) 
  {
    const Entity = GetEntity(searchNumberEvent.entity)
    if (Entity == null) { return }          
          
    if ((mWaitingForRecognitionContact.current && (Entity.type === "contact"))
      || (mWaitingForRecognitionAccount.current && (Entity.type === "account")))
    {
      if (Entity.type === "contact") { mWaitingForRecognitionContact.current = false }
      else if (Entity.type === "account") { mWaitingForRecognitionAccount.current = false }

      if (searchNumberEvent.error != null)
      {
        console.log("SearchNumberEventContact failed", searchNumberEvent.error)
      }
      else if ((searchNumberEvent.response?.entities != null) && (searchNumberEvent.response.entities.length > 0))
      {
        searchNumberEvent.response.entities.map((searchResult) => mRecognitionBuffer.current.push(EmbeddedDynamicsSearchResult(searchResult[Entity.nameField], searchNumberEvent.entity, searchResult[Entity.idField])))        
      }
    
      if (!mWaitingForRecognitionContact.current && !mWaitingForRecognitionAccount.current)
      {
        //recognition finished
        console.log("SearchNumber finished", mRecognitionBuffer.current, props.PrimaryTab)

        const callString = localStorage.getItem("newestcallevent")
        const call = !IsEmptyString(callString) ? JSON.parse(callString) : null
        const callData = call != null ? CallData(call) : null

        try { EmbeddedSetEmbeddedRecognition(JSON.stringify(mRecognitionBuffer.current)) } 
          catch(error) { console.log("EmbeddedSetEmbeddedRecognition error",error) }
        EmbeddedSetEmbeddedRecognitionSelectedIndex(0)
        if (mRecognitionBuffer.current.length > 0)
        {
            const script = {ScreenpopUrl: DynamicsScreenpopUrlCreate(mRecognitionBuffer.current[0]), Name: "Open " + ucfirst(mRecognitionBuffer.current[0].type)}
            props.OnSetHistoryCallRecognition(callData.id, mRecognitionBuffer.current[0].name, "Dynamics", [script])
        } 

        SetRepainter(uuidv4())
        TryAutomaticActions(callData,mRecognitionBuffer.current)
      }
    }
  }

  function DynamicsAPI_ProcessEvent_CreateRecord(createRecordEvent) 
  {
    if (createRecordEvent.error != null)
    {
      console.log("CreateRecord failed", createRecordEvent.error)
    }
    else if (createRecordEvent.response?.id != null)
    {
      if (mCreateRecordCache.current?.entity === "phonecall")
      {        
        EmbeddedDynamicsSetLastInsertedCallId(mCreateRecordCache.current?.callid)
        EmbeddedDynamicsSetLastInsertedDynamicsCallId(createRecordEvent.response.id)
        SetRepainter(uuidv4())
      }
      else 
      {
        const entity = GetEntity(mCreateRecordCache.current?.entity)
        if (entity != null)
        {
          const RecognitionItem = EmbeddedDynamicsSearchResult(mCreateRecordCache.current.name, entity.type, createRecordEvent.response?.id) 

          try { EmbeddedSetEmbeddedRecognition(JSON.stringify([RecognitionItem])) } 
            catch(error) { console.log("EmbeddedSetEmbeddedRecognition error",error) }
          EmbeddedSetEmbeddedRecognitionSelectedIndex(0)
          if (mRecognitionBuffer.current.length > 0)
          {
              const script = {ScreenpopUrl: DynamicsScreenpopUrlCreate(RecognitionItem), Name: "Open " + ucfirst(RecognitionItem.type)}
              props.OnSetHistoryCallRecognition(mCreateRecordCache.current?.callid, RecognitionItem.name, "Dynamics", [script])
          }

          DynamicsAPI_OpenEntity(createRecordEvent.response?.id, entity.type)
          SetRepainter(uuidv4())
        }
      }
    }
  }

  //END OF DYNAMICS API   

  const EmbeddedDynamicsSearchResult = (name, type, id) => {
    return {
      name: name,
      type: type,
      id: id
    }
  }  

  const GetEntity = (type) => {
    const FilteredEntities = cEntities.filter((entity) => entity.type === type)
    return FilteredEntities.length > 0 ? FilteredEntities[0] : null
  }  

  const NewCallState = (calldata) =>
  {
    if (props.PrimaryTab)
    {
      const embeddedRecognition = EmbeddedGetEmbeddedRecognition()
      if (embeddedRecognition === null)
      {
        //Null means recognition is still being queried
        return
      }

      TryAutomaticActions(calldata,embeddedRecognition)
    }
  }

  const ReplaceFields = (input,callData,name) => {
    const isoTime = new Date(callData.starttime).toISOString()
    const formattedStartTime = isoTime.substring(0, isoTime.lastIndexOf(".")) + "Z"  

    let output = input
    output = output.replaceAll("<callid>",callData.id)
    output = output.replaceAll("<number>",callData.opn)
    output = output.replaceAll("<name>",name)
    output = output.replaceAll("<extension>",callData.extension)
    output = output.replaceAll("<ddi>",callData.ddi)
    output = output.replaceAll("<ddiname>",callData.ddiname)
    output = output.replaceAll("<callstart>",formattedStartTime)
    output = output.replaceAll("<calltime>",TimeDifferenceInMinutesAndSeconds(callData.endedtime - callData.starttime))
    output = output.replaceAll("<talktime>",TimeDifferenceInMinutesAndSeconds(callData.endedtime - callData.answeredtime))
    return output
  }

  const TryAutomaticActions = (calldata,contacts) =>
  {
    console.log("TryAutomaticActions",calldata,contacts)
      
    //Automatic action: create call
    let callJustCreated = false
    const settingautocreatecall = EmbeddedDynamicsGetSettingAutoCreateCall() === "yes"
    if (settingautocreatecall)
    {
      const CallId = EmbeddedDynamicsGetLastInsertedCallId()
      if (CallId !== calldata.id)
      {
        DynamicsAPI_CreateCall(calldata, (contacts != null) && (contacts.length > 0) ? contacts[0] : null)
        callJustCreated = true
      }
    }
        
    //Automatic action: pop single-match
    const settingautoopenmatch = EmbeddedDynamicsGetSettingAutoOpenMatch()
    console.log("settingautoopenmatch",settingautoopenmatch,contacts)
    if ((contacts != null) && (contacts.length === 1) &&
      ((settingautoopenmatch === "started") || ((settingautoopenmatch === "answered") && (calldata.state === "answered"))))
    {
      const LastAutoOpenMatch = EmbeddedDynamicsGetLastAutoOpenMatch()
      EmbeddedDynamicsSetLastAutoOpenMatch(calldata.id)
      if (LastAutoOpenMatch !== calldata.id)
      {
        DynamicsAPI_OpenEntity(contacts[0].id, contacts[0].type)
      }
    }

    //Automatic action: create contact when no match is found
    const settingautocreatematch = EmbeddedDynamicsGetSettingAutoCreateMatch() 
    const settingautocreatematchwhen = (settingautocreatematch === "started_contact") || (settingautocreatematch === "started_account") ? "started" :
      (settingautocreatematch === "answered_contact") || (settingautocreatematch === "answered_account") ? "answered" : ""
    const settingautocreatematchwhat = (settingautocreatematch === "started_contact") || (settingautocreatematch === "answered_contact") ? "contact" :
      (settingautocreatematch === "started_account") || (settingautocreatematch === "answered_account") ? "account" : ""
    if ((contacts != null) && (contacts.length === 0) && !IsEmptyString(settingautocreatematchwhat)
      ((settingautocreatematchwhen === "started") || ((settingautocreatematchwhen === "answered") && (calldata.state === "answered"))))
    {
      const LastAutoCreateMatch = EmbeddedDynamicsGetLastAutoCreateMatch()
      EmbeddedDynamicsSetLastAutoCreateMatch(calldata.id)
      if (LastAutoCreateMatch !== calldata.id)
      {
        DynamicsAPI_CreateEntity(calldata.opn, settingautocreatematchwhen)
      }
    } 

    //Automatically update the callduration when ended if a call has been added already
    if ((calldata.state === "ended") && !callJustCreated)
    {
      const lastInsertedCallId = EmbeddedDynamicsGetLastInsertedCallId()
      const lastInsertedDynamicsCallId = EmbeddedDynamicsGetLastInsertedDynamicsCallId()
      if ((lastInsertedCallId === calldata.id) && !IsEmptyString(lastInsertedDynamicsCallId))
      {
        DynamicsAPI_UpdateCallDuration(lastInsertedDynamicsCallId,calldata)
      }
    }
  }

  //////

  const DynamicsCreateEntity = async (number,type) =>
  {
    DynamicsAPI_CreateEntity(number, GetEntity(IsEmptyString(type) ? "contact" : type))
  }

  const DynamicsFinalize = () => 
  {
    return () => window.removeEventListener("message", HandleDynamicsEvent);
  }

  const DynamicsGetAdditionalCallActions = (calldata) =>
  {
    const lastInsertedCallId = EmbeddedDynamicsGetLastInsertedCallId()
    const lastInsertedDynamicsCallId = EmbeddedDynamicsGetLastInsertedDynamicsCallId()
    const embeddedRecognition = EmbeddedGetEmbeddedRecognition()
    const contact = (embeddedRecognition != null) && (embeddedRecognition.length > 0) ? embeddedRecognition[0] : null

    const CreateAccountAction = <img className="clickable" src={CreateAccountPng} title={Translate("Create and show account")} style={{ width: "40px", marginTop: "4px", cursor: "pointer"}} onClick={() => DynamicsCreateEntity(calldata.opn,"account")}/>
    const CreateContactAction = <img className="clickable" src={CreateContactPng} title={Translate("Create and show contact")} style={{ width: "40px", marginTop: "4px", cursor: "pointer"}} onClick={() => DynamicsCreateEntity(calldata.opn,"contact")}/>
    const CreateCallAction = <img className="clickable" src={CreateCallPng} title={Translate("Add call to Dynamics")} style={{ width: "40px", marginTop: "4px", cursor: "pointer"}} onClick={() => DynamicsAPI_CreateCall(calldata, contact)}/>
    const OpenCallAction = <img className="clickable" src={OpenCallPng} title={Translate("Show call")} style={{ width: "40px", marginTop: "4px", cursor: "pointer"}} onClick={() => DynamicsAPI_OpenEntity(lastInsertedDynamicsCallId,"phonecall")}/>

    return <>
      {(embeddedRecognition != null) && (embeddedRecognition.length === 0) ? <>&nbsp;{CreateContactAction}&nbsp;{CreateAccountAction}</> : <></>}
      {(lastInsertedCallId != calldata.id) ? <>&nbsp;{CreateCallAction}</> : <>&nbsp;{OpenCallAction}</>}
    </>
  }

  const DynamicsGetAdditionalCallInfoNode = (calldata) =>
  {
    const lastInsertedCallId = EmbeddedDynamicsGetLastInsertedCallId()
    if (!IsEmptyString(calldata.id) && (lastInsertedCallId === calldata.id))
    {
      const lastInsertedDynamicsCallId = EmbeddedDynamicsGetLastInsertedDynamicsCallId()
      const embeddedRecognition = EmbeddedGetEmbeddedRecognition()
      const name = (embeddedRecognition != null) && (embeddedRecognition.length > 0) ? embeddedRecognition[0].name : ""
      
      return <>
        <textarea rows="1" style={{ width: '100%',  flex: '1', padding: '6px', marginTop: '4px', resize: 'none' }} value={mCallSubject} placeholder={Translate("Subject")} onChange={(evt) => { SetCallSubject(evt.target.value); }}/>
        <select style={{ width: '100%', padding: '6px' }} value={mCallPriority} onChange={(event) => { SetCallPriority(event.target.value) }}>
          {cPriorities.map((priority) => <option style={{ padding: '6px' }} value={priority.value} key={priority.value}>{priority.caption}</option>)}
        </select>
        <textarea style={{ width: '100%', flex: '1', padding: '6px', marginTop: '4px', resize: 'none' }} value={mCallDescription} placeholder={Translate("Description")} onChange={(evt) => { SetCallDescription(evt.target.value); }}/> 
        <Button variant="info" className={GetBrandButtonClass(props.Brand)} style={{ width: '100%' }} onClick={() => DynamicsAPI_UpdateCall(lastInsertedDynamicsCallId, calldata, name)}>{Translate("Update call")}</Button>
      </>
    }
    else
    {
      return <></>
    }
  }

  const DynamicsGetContactDisplayName = (contact) =>
  {
    return contact.name
  }

  const DynamicsGetContactIcon = (contact) =>
  {
    const Entity = GetEntity(contact.type)
    return Entity != null ? Entity.png : ""
  }

  const DynamicsInitialize = () => 
  {
    const windowUrl = window.location.search;
    var params = new URLSearchParams(window.location.search);
    const origin = params.get("origin")
    SetFrameOrigin(origin ?? "")

    window.addEventListener("message", DynamicsAPI_ProcessEvent);

    DynamicsAPI_IntializeDynamics()   
  } 

  const DynamicsNewCallEvent = (calldata,contacts) =>
  {
    EmbeddedDynamicsGetLastInsertedCallId("")
    EmbeddedDynamicsSetLastInsertedDynamicsCallId("")
    SetCallPriority(calldata.inbound ? EmbeddedDynamicsGetSettingDefaultInboundCallPriority() : EmbeddedDynamicsGetSettingDefaultOutboundCallPriority())
    SetCallSubject(calldata.inbound ? EmbeddedDynamicsGetSettingDefaultInboundCallSubject() : EmbeddedDynamicsGetSettingDefaultOutboundCallSubject())
    SetCallDescription(calldata.inbound ? EmbeddedDynamicsGetSettingDefaultInboundCallDescription() : EmbeddedDynamicsGetSettingDefaultOutboundCallDescription())

    NewCallState(calldata,contacts)
  }

  const DynamicsNewCallStateEvent = (calldata) =>
  {
    if (props.PrimaryTab)
    {
      NewCallState(calldata,null)
    }
  }

  const DynamicsOpenContact = (contact) => 
  {
    DynamicsAPI_OpenEntity(contact.id, contact.type)
  }

  const DynamicsScreenpopUrlCreate = (contact) => 
  {
    return "embedded://dynamics." + contact.id + "." + contact.type
  }
  
  const DynamicsScreenpopUrlExecute = (url) => 
  {
    const prefix = "embedded://";
    if (!url.startsWith(prefix)) 
    {
      //This is a regular script, perhaps created earlier
      OpenPopup(url)
    }
    else
    {
      const parts = url.slice(prefix.length).split(".");
      if (parts.length > 0) 
      {
        if (parts[0] === "dynamics")
        {
          if (parts.length === 3)
          {             
            OpenEntity(parts[1],parts[2])
          }
          else
          {
            console.log("Invalid popup value: " + aUrl)
          }
        }
        else
        {
          console.log("Dynamics Embedded cannot execute scripts for embedded " + parts[0])
        }
      }
      else
      {
        console.log("Empty popup value")
      }
    }
  }

  const DynamicsSearchContacts = async (number) => 
  {
    try 
    {
        let formattedNumber = number.replace(/\D/g,'')
        if (formattedNumber.length > 9) { formattedNumber = formattedNumber.slice(-9) }
        else if (formattedNumber.length > 6) { formattedNumber = formattedNumber.slice(-6) }

        mRecognitionBuffer.current = []
        mWaitingForRecognitionContact.current = true
        mWaitingForRecognitionAccount.current = true

        DynamicsAPI_SearchNumber(formattedNumber)
    } 
    catch (error) 
    {
        console.error("Failed to parse phone number: ", error.message);
    }
    return null
  }  

  return <Embedded 
    Calls={props.Calls}
    SecurityToken={props.SecurityToken}
    PhoneApiError={props.PhoneApiError}
    LastCallEventId={props.LastCallEventId}
    Brand={props.Brand}
    RecognitionCacheQueryingNumbers={props.RecognitionCacheQueryingNumbers}
    SpeedDials={props.SpeedDials}
    PrimaryTab={props.PrimaryTab}
    OnAddToSpeedDial={props.OnAddToSpeedDial}
    OnClearCall={props.OnClearCall}
    OnMakeCall={props.OnMakeCall}
    OnRemoveFromCallHistory={props.OnRemoveFromCallHistory}
    OnRemoveFromSpeedDial={props.OnRemoveFromSpeedDial}
    OnSetHistoryCallRecognition={props.OnSetHistoryCallRecognition}

    Crm="Dynamics"
    OnCreateContact={(number,type) => DynamicsCreateEntity(number,type)}
    OnFinalize={() => DynamicsFinalize()}
    OnGetAdditionalCallActions={(calldata,) => DynamicsGetAdditionalCallActions(calldata)}
    OnGetAdditionalCallInfoNode={(calldata,) => DynamicsGetAdditionalCallInfoNode(calldata)}
    OnGetContactDisplayName={(contact,) => DynamicsGetContactDisplayName(contact)}
    OnGetContactIcon={(contact,) => DynamicsGetContactIcon(contact)}
    OnInitialize={() => DynamicsInitialize()}
    OnNewCallEvent={(calldata,contacts) => DynamicsNewCallEvent(calldata,contacts)}
    OnNewCallStateEvent={(calldata) => DynamicsNewCallStateEvent(calldata)}
    OnOpenContact={(contact) => DynamicsOpenContact(contact)}
    OnScreenpopUrlCreate={(contact) => DynamicsScreenpopUrlCreate(contact)}
    OnScreenpopUrlExecute={(url) => DynamicsScreenpopUrlExecute(url)}
    OnSearchContacts={(number) => DynamicsSearchContacts(number)}/>
}

EmbeddedDynamics.propTypes = {
  Calls: PropTypes.array,
  SecurityToken: PropTypes.string,
  PhoneApiError: PropTypes.string,
  LastCallEventId: PropTypes.string, //used for repainting purposes. updates on call event
  Brand: PropTypes.string,
  RecognitionCacheQueryingNumbers: PropTypes.array,
  SpeedDials: PropTypes.array,
  PrimaryTab: PropTypes.bool,
  OnAddToSpeedDial: PropTypes.func,
  OnClearCall: PropTypes.func,
  OnMakeCall: PropTypes.func,
  OnRemoveFromCallHistory: PropTypes.func,
  OnRemoveFromSpeedDial: PropTypes.func,
  OnSetHistoryCallRecognition: PropTypes.func
}

export default EmbeddedDynamics